import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'react-bootstrap-button-loader';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { show } from 'redux-modal';
import moment from 'moment';
import { push } from 'react-router-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setLoader, removeLoader } from '../../../../actions';
import { AdvertiserApi } from '../../../../api';
import { StatBar, DateRange } from '../../../../components/common';
import { humanize } from '../../../../utils/helpers/text_formatters';
import { convertMillsToDollars } from '../../../../utils/helpers/currency';
import { calendarRanges } from '../../../../utils/helpers/calendar_ranges';
import { CampaignsForm } from '../../../../components/advertisers/campaigns';
import { AdsInCampaignTable, AdsForm } from '../../../../components/advertisers/ads';
import { ButtonAdd } from '../../../../components/common/buttons';

class Show extends Component {
  state = {
    start_date: moment().startOf('month'),
    end_date: moment().endOf('month'),
  }

  componentDidMount() {
    this.fetchResource();
  }

  fetchResource(params = {}) {
    const { account, dispatch, params: { campaignId } } = this.props;
    if (account.uuid && campaignId) {
      const data = { account_id: account.uuid, id: campaignId };
      dispatch(AdvertiserApi.actions.standardCampaign.get(data, (_error, success) => {
        if (success) {
          const reportData = {
            account_id: account.uuid,
            campaign_id: campaignId,
            since: params.start_date || moment().startOf('month').format('ddd, DD MMM YYYY'),
            until: params.end_date || moment().endOf('month').format('ddd, DD MMM YYYY'),
          };
          dispatch(AdvertiserApi.actions.campaignReport.get(reportData));
        }
      }));
    }
  }

  handleStatus(action) {
    const { dispatch, account, campaign } = this.props;

    const args = [account.uuid, campaign.id, {
      status: action === 'pause' ? 'paused' : 'active'
    }];

    dispatch(setLoader('CampaignStatusUpdate'));
    dispatch(AdvertiserApi.actions.standardCampaignUpdate.patch(...args, (_error, success) => {
      dispatch(removeLoader('CampaignStatusUpdate'));
      if (success) {
        dispatch({
          type: AdvertiserApi.events.standardCampaign.actionSuccess,
          syncing: false,
          data: { ...campaign, data: success.data }
        });
      }
    }));
  }

  handleDateApply(d) {
    this.setState({ start_date: d.startDate, end_date: d.endDate }, () => {
      this.fetchResource({
        start_date: d.startDate.format('ddd, DD MMM YYYY'),
        end_date: d.endDate.format('ddd, DD MMM YYYY'),
      });
    });
  }

  handleCreateAd() {
    const { dispatch, campaign, account } = this.props;

    window.scrollTo(0, 0);
    dispatch(push(`/advertiser/home/accounts/${account.slug}/ads/new?campaign_id=${campaign.id}`));
  }

  handleEdit() {
    const { dispatch, campaign, account } = this.props;

    dispatch(show('EditCampaignModal', {
      account,
      selfServeCampaignId: campaign.id,
      heading: `Editing Campaign - ${campaign.name}`,
      formAction: 'Update',
      initialValues: {
        ...campaign,
        budget: convertMillsToDollars(campaign.budget)
      },
    }));
  }

  render() {
    const {
      campaign,
      statusLoading,
      adStatusLoading,
      totaledCampaignReport,
      campaignReportLoading,
      account
    } = this.props;

    const campaignNotEditable = () => {
      return (campaign.effective_status === 'campaign_removed' || campaign.effective_status === 'campaign_ended');
    };

    const renderCampaignEndedAlert = () => {
      return (
        <div className="alert alert-warning">
          <FontAwesomeIcon icon="exclamation-circle" />&nbsp;
          You will not be able to modify the details of this campaign because this campaign has&nbsp;
          { campaign.effective_status === 'campaign_removed' ? 'been removed' : 'ended' }.
        </div>
      );
    };

    const action = (['active', 'pending'].includes(campaign.status)) ? 'pause' : 'resume';
    
    const displayEndDate = () => {
      return (
        campaign.recurring ? 
          <div>(Recurring)</div> : 
          <div>
            {campaign.end_date || endDateDefault()}
          </div>
      );
    };

    const endDateDefault = () => {
      return (
        <span>
          {moment().endOf('month').format('YYYY-MM-DD')} &nbsp;
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="recurring-overlay-tooltip" style={{ zIndex: 10001 }}>
                No end date specified and campaign is not recurring.  This campaign will stop at the end of the month.
                  </Tooltip>
            }
          >
            <FontAwesomeIcon icon="question-circle" />
          </OverlayTrigger>
        </span>
      );
    };

    return (
      <div>
        { campaignNotEditable() && renderCampaignEndedAlert()}
        <div className="row">
          <div className="col-md-12 pull-left">
            <DateRange
              key='daterange-ad-cu-dash'
              defaultChosenLabel='This Month'
              opens='right'
              startDate={this.state.start_date}
              endDate={this.state.end_date}
              ranges={calendarRanges}
              onApply={this.handleDateApply.bind(this)}
            />
          </div>
        </div>
        <br />
        <div className='row'>
          <div className="col-md-12">
            <div className='ibox'>
              <div className='ibox-title border-bottom'>
                <h5>{campaign.name}</h5>
                <div className='pull-right'>
                  {(['active', 'pending', 'paused'].includes(campaign.status)) ?
                    <Button
                      type='button'
                      loading={statusLoading}
                      bsStyle={action === 'pause' ? 'warning' : 'success'}
                      className='btn-xs'
                      onClick={this.handleStatus.bind(this, action)}
                      style={{ marginRight: '5px' }}
                      disabled={campaignNotEditable()}
                    >
                      <span>{humanize(action)}</span>
                    </Button> : null}

                  <Button
                    type='button'
                    loading={statusLoading}
                    bsStyle='success'
                    className='btn-xs'
                    onClick={this.handleEdit.bind(this, action)}
                    disabled={campaignNotEditable()}
                  >
                    Edit
                  </Button>
                </div>
              </div>
              <div className="ibox-content">
                <div className="row">
                  <div className="col-md-3 col-sm-6">
                    <h5>Mo. Budget</h5>
                    <div>{`$${convertMillsToDollars(campaign.budget)}`}</div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <h5>Status</h5>
                    <div className={`campaign-status ${campaign.effective_status}`}>{campaign.effective_status}</div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <h5>Start Date</h5>
                    <div>{campaign.start_date}</div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <h5>
                      End Date
                      </h5>
                      {displayEndDate()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <StatBar
            label='Clicks'
            value={totaledCampaignReport ?
              totaledCampaignReport.clicks : 0}
            isLoading={campaignReportLoading}
          />
          <StatBar
            label='Impressions'
            value={totaledCampaignReport ?
              totaledCampaignReport.impressions : 0}
            isLoading={campaignReportLoading}
          />
          <StatBar
            label='Applications'
            value={totaledCampaignReport ?
              totaledCampaignReport.conversions : 0}
            isLoading={campaignReportLoading}
          />
          <StatBar
            label='Total Cost ($)'
            value={totaledCampaignReport ?
              convertMillsToDollars(totaledCampaignReport.spend) : 0}
            isLoading={campaignReportLoading}
          />
          <StatBar
            label='CPA ($)'
            value={totaledCampaignReport && totaledCampaignReport.conversions > 0 ?
              ((convertMillsToDollars(totaledCampaignReport.cpaSpend) / totaledCampaignReport.conversions)).toFixed(2) : 0
            }
            isLoading={campaignReportLoading}
          />
          <StatBar
            label='CPC ($)'
            value={totaledCampaignReport && totaledCampaignReport.clicks > 0 ?
              (convertMillsToDollars(totaledCampaignReport.cpcSpend) / totaledCampaignReport.clicks).toFixed(2) : 0
            }
            isLoading={campaignReportLoading}
          />
          <StatBar
            label='CTR (%)'
            value={totaledCampaignReport && totaledCampaignReport.impressions !== 0 ?
              ((totaledCampaignReport.clicks / totaledCampaignReport.impressions) * 100).toFixed(2) : 0}
            isLoading={campaignReportLoading}
          />
          <StatBar
            label='Total Cost per Day ($)'
            value={totaledCampaignReport ?
              (convertMillsToDollars(totaledCampaignReport.spend) /
              ((this.state.end_date.endOf('day').diff(this.state.start_date.startOf('day'), 'day') || 1))).toFixed(2) : 0}
            isLoading={campaignReportLoading}
          />
        </div>
        <div className='row'>
          <div className="col-md-12">
            <div className='ibox'>
              <div className='ibox-title border-bottom'>
                <h5>Ads</h5>
              </div>
              <AdsInCampaignTable account={account} startDate={this.state.start_date} endDate={this.state.end_date} campaign={campaign}>
                <ButtonAdd
                  loading={adStatusLoading}
                  btnLabel='Create Ad'
                  onClick={this.handleCreateAd.bind(this, action)}
                  disabled={campaignNotEditable()}
                />
              </AdsInCampaignTable>
            </div>
          </div>
        </div>
        <AdsForm />
        <CampaignsForm />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    loader,
    advertiser: {
      standardCampaign: { data: { data: campaign }, loading: campaignIsLoading },
      ads: { data: ads },
      adReports: { data: adReports },
      campaignReport: { data: campaignReports, loading: campaignReportLoading },
      accounts,
    }
  } = state;
  const { params: { accountSlug } } = ownProps;
  const account = (accounts.data.data || [])
    .filter((w) => w.slug === accountSlug)[0] || {};

  const totaledCampaignReport = {
    count: 0,
    clicks: 0,
    conversions: 0,
    impressions: 0,
    spend: 0,
    cpcSpend: 0,
    cpaSpend: 0
  };

  if (campaignReports.data && campaign) {
    campaignReports.data.forEach((currentValue) => {
      if (currentValue.bid_type === 'cpc') {
        totaledCampaignReport.cpcSpend += currentValue.spend;
      } else if (currentValue.bid_type === 'cpa') {
        totaledCampaignReport.cpaSpend += currentValue.spend;
      }
      totaledCampaignReport.spend += currentValue.spend;
      totaledCampaignReport.clicks += currentValue.clicks;
      totaledCampaignReport.conversions += currentValue.conversions;
      totaledCampaignReport.impressions += currentValue.impressions;
    });
  }
  return {
    account,
    ads,
    adReports,
    campaign: campaign || {},
    campaignReport: campaignReports || [],
    campaignIsLoading,
    campaignReportLoading,
    totaledCampaignReport,
    statusLoading: loader.includes('CampaignStatusUpdate'),
    adStatusLoading: loader.includes('AdStatusUpdate')
  };
};

export default connect(mapStateToProps)(Show);
